import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const RegisterPage = lazy(() => import("./RegisterPage"));

const RegisterPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <RegisterPage />
    </Suspense>
  );
};

export default RegisterPageLazy;
